import {requests} from "../../helpers/api.services";
import {INFO_URL} from "../../helpers/api.routes";
import {IInfo} from "./interface";

export const AdminInfoService = {
    get: () => requests.get(INFO_URL),
    create: (params: IInfo) => requests.post(INFO_URL, params)
}